export const sizing = {
  maxAppWidthPx: 600,
  horizontalGuttersPx: 16, // space between app content and screen edges
  maxAppContentWidthPx: 568, // maxAppWidthPx - (horizontalGuttersPx * 2)
};
